import React from "react";
import { Box, Container, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Footers = styled.div`
  width: 100%;
  height: 520px;
  display: flex;
  background: linear-gradient(160deg, #2b2118 0%, #8b2635 100%);
  background-size: cover;
`;

export function Footer() {
  return (
    <Footers>
      <Container>
        <Stack flexDirection={"row"} sx={{ mt: "94px" }}>
          <Stack flexDirection={"column"} style={{ width: "340px" }}>
            <Box>
              <span className="brand-logo footer-brand">BOOCLUB</span>
            </Box>
            <Box className={"foot-desc-txt"}>
              BooClub brings readers together around carefully curated books,
              community reviews, and bookstore experiences worth keeping.
            </Box>
            <Box className="sns-context">
              <img src={"/icons/facebook.svg"} alt="" />
              <img src={"/icons/twitter.svg"} alt="" />
              <img src={"/icons/instagram.svg"} alt="" />
              <img src={"/icons/youtube.svg"} alt="" />
            </Box>
          </Stack>
          <Stack sx={{ ml: "288px" }} flexDirection={"row"}>
            <Stack>
              <Box>
                <Box className={"foot-category-title"}>Sections</Box>
                <Box className={"foot-category-link"}>
                  <Link to="/">Home</Link>
                  <Link to="/products">Products</Link>
                  <Link to="/community">Community</Link>
                  <Link to="/help">Help</Link>
                </Box>
              </Box>
            </Stack>
            <Stack sx={{ ml: "100px" }}>
              <Box>
                <Box className={"foot-category-title"}>Find us</Box>
                <Box
                  flexDirection={"column"}
                  sx={{ mt: "20px" }}
                  className={"foot-category-link"}
                  justifyContent={"space-between"}
                >
                  <Box flexDirection={"row"} className={"find-us"}>
                    <span>L.</span>
                    <div>Seoul · Book District</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span>P.</span>
                    <div>+82 2 000 0000</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span>E.</span>
                    <div>hello@booclub.app</div>
                  </Box>
                  <Box className={"find-us"}>
                    <span>H.</span>
                    <div>Open daily 10:00–22:00</div>
                  </Box>
                </Box>
              </Box>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          style={{ border: "1px solid #C5C8C9", width: "100%", opacity: "0.2" }}
          sx={{ mt: "80px" }}
        ></Stack>
        <Stack className={"copyright-txt"}>
          © Copyright BooClub, All rights reserved.
        </Stack>
      </Container>
    </Footers>
  );
}
